function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function() {
  return this.each(remove);
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-selection/src/selection/remove.js
// module id = ../../../../d3-selection/src/selection/remove.js
// module chunks = 3